export interface RentLimit {
  rentPriceCold: number;
  sideCosts: number;
}

const _rentLimits: Record<number, RentLimit> = {
  1: {
    rentPriceCold: 400,
    sideCosts: 170,
  },
  2: {
    rentPriceCold: 490,
    sideCosts: 200,
  },
  3: {
    rentPriceCold: 590,
    sideCosts: 230,
  },
  4: {
    rentPriceCold: 780,
    sideCosts: 260,
  },
  5: {
    rentPriceCold: 930,
    sideCosts: 300,
  },
  6: {
    rentPriceCold: 1000,
    sideCosts: 310,
  },
};

const _rentLimitsBarrierfree: Record<number, RentLimit> = {
  1: {
    rentPriceCold: 530,
    sideCosts: 170,
  },
  2: {
    rentPriceCold: 680,
    sideCosts: 200,
  },
  3: {
    rentPriceCold: 840,
    sideCosts: 230,
  },
  4: {
    rentPriceCold: 1000,
    sideCosts: 260,
  },
  5: {
    rentPriceCold: 1150,
    sideCosts: 300,
  },
  6: {
    rentPriceCold: 1310,
    sideCosts: 310,
  },
};

const _rentLimitsEnergetic: Record<number, RentLimit> = {
  1: {
    rentPriceCold: 490,
    sideCosts: 170,
  },
  2: {
    rentPriceCold: 590,
    sideCosts: 200,
  },
  3: {
    rentPriceCold: 710,
    sideCosts: 230,
  },
  4: {
    rentPriceCold: 920,
    sideCosts: 260,
  },
  5: {
    rentPriceCold: 1080,
    sideCosts: 300,
  },
  6: {
    rentPriceCold: 1160,
    sideCosts: 310,
  },
};

export type DataToFill = {
  numberOfPersons?: number | 'manual';
  rentPriceCold?: number;
  sideCosts?: number;
  isEnergeticallyRenovated?: boolean;
  isBarrierFree?: boolean;
};

export type ResultData = Required<DataToFill>;

export function getRentLimits(
  numberOfPersons: number | 'manual',
  { isBarrierFree, isEnergeticallyRenovated }: { isEnergeticallyRenovated?: boolean; isBarrierFree?: boolean }
): RentLimit | null {
  if (numberOfPersons === 'manual') {
    return null;
  }
  if (isBarrierFree) {
    return _rentLimitsBarrierfree[numberOfPersons];
  }
  if (isEnergeticallyRenovated) {
    return _rentLimitsEnergetic[numberOfPersons];
  }
  return _rentLimits[numberOfPersons];
}
